// @ts-nocheck
import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {UserTwoStepsCell} from './UserTwoStepsCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {User} from '../../core/_models'
import UserPhoneNumberCell from './UserPhoneNumberCell'
import UserGenderCell from './UserGenderCell'
import UserLocationCell from './UserLocationCell'
import {UserStatusCell} from './UserStatusCell'
import {UserActionsCell} from './UserActionsCell'
import UserDateCell from './UserDateCell'
import {InstructorInfoCell} from './InstructorInfoCell'
import moment from 'moment'

const usersColumns: ReadonlyArray<Column<User>> = [
  // {
  //   Header: (props) => <UserSelectionHeader tableProps={props} />,
  //   id: '_id',
  //   Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index]._id} />,
  // },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Name' className='min-w-125px' />,
    id: 'name',
    accessor: 'name',
    Cell: ({...props}) => <UserInfoCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Start Time' className='min-w-125px' />
    ),
    id: 'startTime',
    accessor: 'startTime',
    Cell: ({...props}) => <UserDateCell phone={props.data[props.row.index].startTime} />,
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='End Time' className='min-w-125px' />
    ),
    id: 'endTime',
    accessor: 'endTime',
    Cell: ({...props}) => <UserDateCell phone={props.data[props.row.index].endTime} />,
  },

  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Instructors/ Businesses '
        className='min-w-125px'
      />
    ),
    id: 'instructor',
    accessor: 'instructor',
    Cell: ({...props}) => (
      <InstructorInfoCell
        user={
          props.data[props.row.index].instructor
            ? props.data[props.row.index].instructor
            : props.data[props.row.index].createdBy
        }
        type={props.data[props.row.index].instructor ? 'instructor' : 'business'}
      />
    ),
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Created At' className='min-w-125px' />
    ),
    id: 'created',
    accessor: 'created',
    Cell: ({...props}) => (
      <>
        <div>{moment(props.data[props.row.index].createdAt).format('LL:hh:mm A')}</div>
      </>
    ),
  },

  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Email' className='min-w-125px' />
  //   ),
  //   id: 'email',
  //   accessor: 'email',
  //   Cell: ({...props}) => <UserGenderCell gender={props.data[props.row.index].email} />,
  // },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Type' className='min-w-125px' />
  //   ),
  //   id: 'role',
  //   accessor: 'role',
  //   Cell: ({...props}) => <UserLocationCell phone={props.data[props.row.index].role} />,
  // },

  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Status' className='min-w-125px' />
  //   ),
  //   id: 'isBlocked',
  //   accessor: 'isBlocked',
  //   Cell: ({...props}) => <UserStatusCell isBlocked={props.data[props.row.index].isBlocked} />,
  // },

  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Location' className='min-w-125px' />
  //   ),
  //   id: 'primaryLocation',
  //   accessor: 'primaryLocation',
  //   Cell: ({...props}) => <UserLocationCell phone={props.data[props.row.index].primaryLocation} />,
  // },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-125px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <UserActionsCell id={props.data[props.row.index]._id} />,
  },
]

export {usersColumns}
